<iframe id="frame" src="./mapas/#" width="100%" height="800" frameBorder="0">
  No Compatible con Frames
</iframe>